import React, { useState } from "react";
import { SidebarData } from "./SidebarData.js";
import { useNavigate, useLocation } from "react-router-dom";
import { signOut, getAuth } from "firebase/auth";

function PortfolioNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const auth = getAuth();

  const handleNav = (link) => {
    navigate(link);
    setMobileOpen(false);
  };

  const logout = () => {
    signOut(auth)
      .then(() => navigate("/"))
      .catch(console.error);
  };

  return (
    <>
      <button
        className="BurgerBtn"
        onClick={() => setMobileOpen(true)}
        aria-label="Open menu"
      >
        <i className="fa-solid fa-bars"></i>
      </button>

      {mobileOpen && (
        <div
          className="SideBarOverlay"
          onClick={() => setMobileOpen(false)}
        />
      )}

      <div className={`SideBar${mobileOpen ? " SideBar--open" : ""}`}>
        <div className="SideBar__close-row">
          <button
            className="SideBarCloseBtn"
            onClick={() => setMobileOpen(false)}
            aria-label="Close menu"
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <ul className="SideBarList">
          {SidebarData.map((val, key) => (
            <li
              key={key}
              className="SideBarRow"
              id={location.pathname === val.link ? "active" : ""}
              onClick={() => handleNav(val.link)}
            >
              <div id="icon">{val.icon}</div>
              <div id="title">{val.title}</div>
            </li>
          ))}
        </ul>

        <div className="SideBarLogout">
          <button className="SideBarLogoutBtn" onClick={logout}>
            <div id="icon">
              <i className="fa-solid fa-right-from-bracket"></i>
            </div>
            <div id="title">Log Out</div>
          </button>
        </div>
      </div>
    </>
  );
}

export default PortfolioNavbar;
